var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.84,
    height: 32,
    viewBox: "0 0 28.84 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "share_FILL0_wght400_GRAD0_opsz48",
    d: "M144.28,208a4.49,4.49,0,0,1-4.5-5.226,3.325,3.325,0,0,1,.18-.694l-12.12-7.04a4.57,4.57,0,0,1-1.48,1.1,4.137,4.137,0,0,1-1.8.42,4.56,4.56,0,1,1,1.76-8.76,4.828,4.828,0,0,1,1.52,1.04l12.12-6.96a2.846,2.846,0,0,1-.18-.636,4.086,4.086,0,0,1-.06-.684,4.568,4.568,0,1,1,4.56,4.56,5.346,5.346,0,0,1-1.787-.3,3.421,3.421,0,0,1-1.453-.98l-12.12,6.72a7.39,7.39,0,0,1,.14.74,5.154,5.154,0,0,1,.06.71,3.159,3.159,0,0,1-.06.6q-.06.31-.14.63l12.12,6.88a4.76,4.76,0,0,1,1.4-.9,4.669,4.669,0,0,1,1.84-.34,4.56,4.56,0,1,1,0,9.12Zm0-25.28a2.12,2.12,0,1,0-1.54-.62A2.087,2.087,0,0,0,144.281,182.72Zm-19.72,11.44a2.12,2.12,0,1,0-1.54-.62A2.087,2.087,0,0,0,124.561,194.16Zm19.72,11.44a2.12,2.12,0,1,0-1.54-.62A2.087,2.087,0,0,0,144.281,205.6ZM144.28,180.56ZM124.56,192ZM144.28,203.44Z",
    transform: "translate(-120 -176)",
    fill: "#ed1c24"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.284276fe981944efa6b716b356f4408f.svg";
export { ForwardRef as ReactComponent };